<div class="c-flyover-backdrop" (click)="dismiss()"></div>
<div class="c-flyover">
  <button class="c-flyover__close" (click)="dismiss()"></button>
  <ng-content></ng-content>
</div>